import React, { useEffect, useState } from "react";
import AddActionModal from "../modals/AddActionModal";
import axios from "axios";
import { MdOutlineCancel } from "react-icons/md";
import api from "../../../../utils/api";
import socket from "../../../../context/socket";
// import { X } from "lucide-react";

export const TabTwo = ({ setSelectedTab, selectedTab, isPrsuggections, setPrsuggections, isPortfolioData, roomId, fetchPortfolioData }) => {
  // console.log("isPrsuggections",isPrsuggections,setPrsuggections);

  let [loading, setLoading] = useState(false);
  let [error, setError] = useState("");
  const [selectedText, setSelectedText] = useState(new Set());  
 
  const [checkedActions, setCheckedActions] = useState(
    isPrsuggections.map((action) => action.is_selected === "yes")
  );
  const [showModal, setShowModal] = useState(false);

  const handleAddAction = (newAction) => {
    if (newAction.trim() === "") {
      alert("Action cannot be empty!");
      return;
    }
    setShowModal(false);
  };

  const toggleCheckbox = (index) => {
    const updatedCheckedActions = [...checkedActions];
    updatedCheckedActions[index] = !updatedCheckedActions[index];
    setCheckedActions(updatedCheckedActions);
  };

  // Function to handle "Next" button click
  const handleNext = () => {
    if (selectedTab < 4) {
      setSelectedTab(selectedTab + 1);
    }
  };

  // Function to handle "Back" button click
  const handleBack = () => {
    if (selectedTab > 1) {
      setSelectedTab(selectedTab - 1);
    }
  };


  const handleDelete = async (index, id) => {


    setPrsuggections((prev) => prev.filter((_, i) => i !== index));
    const payload = {
      clientid: roomId,
      pr_id: isPortfolioData?.prinfo?.portfolio_review_id,
      action: "removeactionplan",
      id: id

    };

    try {
      const response = await api.post(`advisor/updateprdataWM`, payload);
      console.log("API Response:", response.data);
    } catch (err) {
      console.error("API Error:", err);
      setError("Failed to add action. Please try again.");
    } finally {
      setLoading(false);
    }
    console.log("Delete clicked");
  }


  // Run once when suggestions change
    useEffect(() => {
      if (isPrsuggections?.length > 0) {
        const defaultChecked = new Set(isPrsuggections.map((action) => action._id));
        setSelectedText(defaultChecked);
      }
    }, [isPrsuggections]);

  useEffect(() => {
    if (roomId) {
      socket.emit("message_to", { room: roomId, data: { selectedText: Array.from(selectedText) } });
      // console.log("Sent to Socket:", Array.from(selectedText));
    }
  }, [selectedText, roomId]);

  // Handling Checkbox Selection
  const handleCheckboxChange = async (cardId) => {
    // Find item from list
    const actionIndex = isPrsuggections.findIndex(item => item._id === cardId);
    if (actionIndex === -1) return;

    // Toggle existing value
    const newValue = isPrsuggections[actionIndex].is_selected === "yes" ? "no" : "yes";

    // Update API
    await api.put(`advisor/updateIsSelectedById/${cardId}`, { is_selected: newValue });

    // Update UI list also
    setPrsuggections(prev => {
      const updated = [...prev];
      updated[actionIndex] = {
        ...updated[actionIndex],
        is_selected: newValue
      };
      return updated;
    });
  };


  return (
    <>
      <div className="container" style={{ minHeight: "500px" }}>
        <p className="clrgreen fs-2 text-center">
          Here's Your Customized Action Plan
        </p>

        <div className="row rowwidth mx-auto">
          <div className="col">
            <div className="card border-0">
              <img
                src="assets/images/key.png"
                className="w-100"
                alt="Action Plan"
              />
              <div className="card-body border border-1">
                <form>
                  {isPrsuggections.map((action, index) => {
                    console.log("action",action);
                  return(
                    <div className="d-flex mt-2" key={action._id}>
                      <label className="d-block mb-2">
                        <input
                          // onBlur={saveActionPoints}
                          className="me-2"
                        type="checkbox"
                        // checked={selectedText.has(action._id)}
                        checked={action.is_selected === "yes"?true : false}
                        onChange={() => handleCheckboxChange(action._id)}
                        />
                      </label>
                        <span>{action.suggestions}</span>
                      {action.type === "CUST" && (
                        <MdOutlineCancel
                          onClick={() => handleDelete(index, action._id)}
                          className="text-danger  fs-5 cursor-pointer mt-1"
                        />
                      )}
                    </div>
                    )
                  })}
                </form>

              </div>
            </div>
          </div>
        </div>

        <button
          className="btn btn-outline-success mt-3"
          onClick={() => setShowModal(true)}
        >
          + Add More
        </button>

        <AddActionModal
          show={showModal}
          onHide={() => setShowModal(false)}
          onAddAction={handleAddAction}
          isPortfolioData={isPortfolioData}
          roomId={roomId}
          fetchPortfolioData={fetchPortfolioData}
          isPrsuggections={isPrsuggections}
          setPrsuggections={setPrsuggections}
        />

        {/* Navigation Buttons */}
        <div className="container">
          <div className="row">
            <div className="col text-end">
              <a
                href="javascript:void(0);"
                onClick={handleBack}
                disabled={selectedTab === 1}
              >
                <img
                  className="arrow_next1"
                  src="assets/images/left-arrowpng.png"
                  alt=""
                />
              </a>
              <a
                href="javascript:void(0);"
                className="ms-1"
                onClick={handleNext}
                disabled={selectedTab === 4}
              >
                <img
                  className="arrow_next"
                  src="assets/images/right-arrow.svg"
                  alt="Next"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
